import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../../shared/services/data-storage.service';
import {Subject, Subscription} from 'rxjs';
import {UserLogin} from '../../../shared/models/user.model';
import {AuthenticationService} from '../../../authentication/authentication.service';
import {EditingService} from '../../../shared/services/editing.service';
import {Payment, PaymentCreate} from '../../../shared/models/payment.model';
import {PaymentService} from '../../../shared/services/payment.service';
import {takeUntil, tap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import swal from 'sweetalert2';
import {LogCreate} from '../../../shared/models/log.model';
import {UserService} from '../../../shared/services/user.service';
import {Reservation} from '../../../shared/models/reservation.model';

@Component({
    selector: 'form-edit-payment',
    templateUrl: 'form-edit-payment.html'
})
export class FormEditPaymentComponent implements OnInit, OnDestroy {

    @Input() payments: Payment[];
    @Input() reservation_id: number;
    @Input() comment: string;
    @Input() reservation: Reservation;

    private userSub: Subscription;
    user: UserLogin;

    amount: number;
    balance: number;

    is_add: boolean;
    ipAddress = '';

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService
        , private authenticationService: AuthenticationService
        , private userService: UserService
        , private http: HttpClient
        , private editingService: EditingService
        , private paymentService: PaymentService) {
        this.amount = 0;
        this.balance = 0;
        this.is_add = false;
    }

    ngOnInit() {

        this.initBalance();

        this.userSub = this.authenticationService.user
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                user => {
                    this.user = user;
                });

        this.editingService.invoiceAmountChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.amount = value;
                if (this.payments) {
                    let paid_amount = 0;
                    for (const payment of this.payments) {
                        paid_amount += payment.amount;
                    }
                    this.balance = this.amount - paid_amount;
                } else {
                    this.balance = this.amount;
                }
            }
        );

        this.paymentService.paymentChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.submitPayment(value);
            }
        );

        this.userService.setIPAddress().pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
                this.ipAddress = res.ip;
            }
        );
    }

    initBalance() {

        this.amount = this.editingService.getInvoice();
        this.balance = this.amount;
        if (this.payments) {
            for (const payment of this.payments) {
                this.balance = this.balance - payment.amount;
            }
        }

    }

    onTogglePayment() {
        this.is_add = !this.is_add;
    }

    onPayWithCard() {
        this.paymentService.paymentProcessEmitter.emit();
    }

    submitPayment(new_payment: PaymentCreate) {
        new_payment.reservation_id = this.reservation_id;
        new_payment.user_id = this.user.id;
        this.dataStorageService.createPayment(new_payment)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData) {
                    alert('Card paid!');
                    this.is_add = false;
                    location.reload();
                }
            }
        );
    }

    onDeletePayment(i: number) {
        const payment = this.payments[i];
        if (payment.type === 'Credit Card') {
            if (payment.square_payment_id) {
                swal({
                    title: 'Really?',
                    text: 'Would you like to refund square payment?',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#f5365c',
                    confirmButtonText: 'Yes, Refund!',
                    cancelButtonText: 'No, Cancel!'
                }).then((result2) => {
                    if (result2.value) {
                        this.http.post('https://server.ozshuttle.com/api/extras/cancel_payment_square.php'
                                , {payment_id: payment.square_payment_id, amount: payment.amount})
                            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                            responseData => {
                                // send and get back from the server
                                if (responseData['refund']) {

                                    // update comment.
                                    const rfndAmount = payment.amount;
                                    const rfndReceiptNumber = payment.square_receipt_number;
                                    const newComment = this.comment ?
                                        this.comment + ' //' + 'SQ Refund ($' + rfndAmount + ') #' + rfndReceiptNumber
                                        : 'SQ Refund ($' + rfndAmount + ') #' + rfndReceiptNumber;
                                    this.dataStorageService.updateReservationComment(newComment, this.reservation_id)
                                        .pipe(takeUntil(this.unsubscribe$)).subscribe(
                                        commentResponse => {

                                            if (commentResponse['error']) {
                                                alert('Payment has been refunded. But failed to update comment. #' + rfndReceiptNumber);
                                            } else {
                                                this.dataStorageService.deletePayment(payment.id)
                                                    .pipe(takeUntil(this.unsubscribe$)).subscribe(
                                                    res => {
                                                        if (res) {
                                                            // add log
                                                            const new_log = new LogCreate(this.user.id, 'SQ Refund ($' + rfndAmount + '.00) #' + payment.square_receipt_number, this.ipAddress);
                                                            new_log.reservation_id = this.reservation_id;
                                                            this.dataStorageService.createLog(new_log)
                                                                .pipe(takeUntil(this.unsubscribe$))
                                                                .subscribe(response => {
                                                                    swal({
                                                                        title: 'Would you like to cancel the reservation?',
                                                                        text: 'Card Refunded.',
                                                                        showCancelButton: true,
                                                                        confirmButtonColor: '#2dce89',
                                                                        cancelButtonColor: '#f5365c',
                                                                        confirmButtonText: 'Yes, Proceed',
                                                                        cancelButtonText: 'No, Keep it'
                                                                    }).then((result) => {
                                                                        if (result.value) {
                                                                            this.onCancel(this.reservation_id);
                                                                        } else {
                                                                            location.reload();
                                                                        }
                                                                    });
                                                                });
                                                        }
                                                    }
                                                );
                                            }

                                        }
                                    );

                                } else {
                                    if (responseData['error']) {
                                        alert(responseData['error']);
                                    } else {
                                        alert('Not refunded. ');
                                    }
                                }
                            }, error => {
                                alert(error);
                            });
                    } else {
                        alert('Okay. ');
                    }
                });
            } else {
                alert('payment info error');
            }
        } else if (payment.type === 'Cash') {
            this.dataStorageService.deletePayment(payment.id).subscribe(
                res => {
                    swal({
                        title: 'Would you like to cancel the reservation?',
                        text: 'Cash Refunded.',
                        showCancelButton: true,
                        confirmButtonColor: '#2dce89',
                        cancelButtonColor: '#f5365c',
                        confirmButtonText: 'Yes, Proceed',
                        cancelButtonText: 'No, Keep it'
                    }).then((result) => {
                        if (result.value) {
                            this.onCancel(this.reservation_id);
                        } else {
                            // save log
                            const rfndAmount = this.amount;
                            const newLog = rfndAmount
                                ? new LogCreate(this.user.id, 'Cash Refund ($' + rfndAmount + '.00)', this.ipAddress)
                                : new LogCreate(this.user.id, 'Reservation canceled. ', this.ipAddress);
                            newLog.reservation_id = this.reservation_id;
                            this.dataStorageService.createLog(newLog).pipe(takeUntil(this.unsubscribe$))
                                .subscribe(responseData => {
                                    alert('Reservation canceled. ');
                                    location.reload();
                                });
                        }
                    });
                });
        } else {
            alert('payment type error');
        }
    }

    onCancel(id: number) {
        this.dataStorageService.updateReservationStatus('canceled', id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (response) => {
                if (response['error']) {
                    alert('Reservation cancellation Failed. ');
                    location.reload();
                } else {
                    alert('Reservation canceled. ');
                    location.reload();
                }
            }
        );
    }

    ngOnDestroy() {
        this.userSub.unsubscribe();

        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
